import { render } from "./NewDealer.vue?vue&type=template&id=1e711beb"
import script from "./NewDealer.vue?vue&type=script&lang=js"
export * from "./NewDealer.vue?vue&type=script&lang=js"

import exportComponent from "/srv/strapi/LessMessAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__